import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Dna, FlaskConical, Heart, Shield } from 'lucide-react';

export default function OrganizationsTab() {
  return (
              <div className="grid md:grid-cols-2 gap-4">
                <a href="https://www.akcchf.org" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                          <Heart className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">AKC Canine Health Foundation</h4>
                            <Badge variant="secondary" className="text-xs">Nonprofit</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Largest nonprofit funder of exclusively canine health research in the world
                          </p>
                          <p className="text-xs text-primary mt-1">akcchf.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.morrisanimalfoundation.org/dogs" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                          <Shield className="w-5 h-5 text-green-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Morris Animal Foundation</h4>
                            <Badge variant="secondary" className="text-xs">Since 1948</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Funds research on cancer, infectious disease, and hereditary conditions
                          </p>
                          <p className="text-xs text-primary mt-1">morrisanimalfoundation.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.akc.org/breeder-programs/dna/dna-resource-center/genetic-diversity-project/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                          <Dna className="w-5 h-5 text-amber-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">AKC Genetic Diversity Project</h4>
                            <Badge className="bg-purple-100 text-purple-700 text-xs">4000+ Dogs</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Premier database covering all AKC breeds for genetic diversity research
                          </p>
                          <p className="text-xs text-primary mt-1">akc.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.canine-genetics.org.uk/research/give-a-dog-a-genome/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                          <FlaskConical className="w-5 h-5 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Give a Dog a Genome (UK)</h4>
                            <Badge variant="secondary" className="text-xs">77 Breeds</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            UK's largest canine genome bank - 89 dogs from 77 breeds sequenced
                          </p>
                          <p className="text-xs text-primary mt-1">canine-genetics.org.uk</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              </div>
  );
}
